import { FeatureFlags } from '@/hooks/useFeatureFlags';

export const getFeatureFlagEnabled = (featureFlags: FeatureFlags, featureName: string) => {
  if (featureFlags[featureName]?.enabled) {
    return true;
  }
  return false;
};
